export function onReady(action) {
  document.addEventListener("DOMContentLoaded", action);
}
export function getElem(selector, container) {
  return (container || document).querySelector(selector);
}
export function getElems(selector, container) {
  return (container || document).querySelectorAll(selector);
}
export function onScroll(action) {
  var previousScrollAmount;
  requestAnimationFrame(doActionThenWaitForNextFrame);

  function doActionThenWaitForNextFrame() {
    var currentScrollAmount = window.scrollY;

    if (currentScrollAmount != previousScrollAmount) {
      action();
      previousScrollAmount = currentScrollAmount;
    } // on next animation frame, trigger same function


    requestAnimationFrame(doActionThenWaitForNextFrame);
  }
}
export function sectionIsInView(section) {
  // top and bottom values are relative to window view
  var _section$getBoundingC = section.getBoundingClientRect(),
      top = _section$getBoundingC.top,
      bottom = _section$getBoundingC.bottom;

  var sectionOutOfView = top > window.innerHeight || bottom < 0;
  return sectionOutOfView ? false : true;
}